import { TableItem } from '../../../components/Tables'

export const ACTIVITIES_TABLE_CONFIG = (row: any): TableItem[] => {
  return [
    {
      type: 'text',
      label: 'Name',
      value: 'name',
      sortable: true,
    },
    {
      type: 'text',
      label: 'Category',
      value: 'category',
      sortable: true,
    },
    {
      type: 'text',
      label: 'Location',
      value: 'location',
      sortable: true,
    },
    {
      type: 'text',
      label: 'Price',
      value: 'price',
      sortable: true,
    },
    {
      type: 'date',
      label: 'Start Time',
      value: 'start_time',
      sortable: true,
    },
    {
      type: 'date',
      label: 'End Time',
      value: 'end_time',
      sortable: true,
    },
  ]
}
